import { render, staticRenderFns } from "./OnestopSetMeal.vue?vue&type=template&id=716f565e"
import script from "./OnestopSetMeal.vue?vue&type=script&lang=js"
export * from "./OnestopSetMeal.vue?vue&type=script&lang=js"
import style0 from "./OnestopSetMeal.vue?vue&type=style&index=0&id=716f565e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports